﻿import Collapse from "./collapse.js";
import Overlay from "./overlay.js";
import SlideToggle from "./slide-toggle.js";

class MobileNav {
  constructor(element) {
    // Check if already initialized
    if (element.dataset.mobileNavInitialized === "true") {
      return;
    }

    this.element = element;
    this.wrapper = element.closest(".mobile-nav-wrapper");
    this.slideToggles = [];
    this.mobileToggle = null;
    this.init();

    // Mark as initialized
    element.dataset.mobileNavInitialized = "true";
  }

  init() {
    // Initialize mobile toggle if exists
    if (this.wrapper) {
      const mobileToggleButton = this.wrapper.querySelector("[data-toggle-nav]");

      if (mobileToggleButton) {
        this.mobileToggle = new SlideToggle(mobileToggleButton, this.element, {
          duration: 300,
          easing: "ease-in-out",
          useHidden: false, // Use class instead of hidden attribute
          toggleClass: "is-open",
        });
      }
    }

    // Initialize all submenu toggle buttons
    const toggleButtons = this.element.querySelectorAll("[data-toggle-nav]");

    toggleButtons.forEach((button) => {
      const submenu = button.closest(".mobile-nav__item-wrapper").nextElementSibling;

      if (submenu && submenu.classList.contains("mobile-nav__list")) {
        const slideToggle = new SlideToggle(button, submenu, {
          duration: 300,
          easing: "ease-in-out",
        });

        this.slideToggles.push(slideToggle);
      }
    });

    // Open parent menus of active links on page load (without animation)
    this.expandActiveItems();
  }

  expandActiveItems() {
    const activeLinks = this.element.querySelectorAll(".mobile-nav__link--active");

    activeLinks.forEach((link) => {
      let parent = link.closest(".mobile-nav__item");

      // Walk up the tree and expand all parent menus
      while (parent) {
        const parentItem = parent.parentElement.closest(".mobile-nav__item");

        if (parentItem) {
          const toggleButton = parentItem.querySelector(
            ":scope > .mobile-nav__item-wrapper > [data-toggle-nav]"
          );

          if (toggleButton) {
            // Find the corresponding SlideToggle instance and expand without animation
            const slideToggle = this.slideToggles.find((st) => st.trigger === toggleButton);
            if (slideToggle) {
              slideToggle.expand();
            }
          }
        }

        parent = parentItem;
      }
    });
  }
}

// Initialize all mobile navs on the page and setup overlay for main mobile nav
document.addEventListener("DOMContentLoaded", () => {
  const mobileNavs = document.querySelectorAll(".mobile-nav");
  mobileNavs.forEach((nav) => new MobileNav(nav));

  // Setup overlay for main mobile nav (using Bootstrap collapse)
  const overlay = Overlay();
  const mobileNav = document.querySelector("#mobile-nav");

  if (mobileNav) {
    const collapseInstance = Collapse();

    collapseInstance.on(mobileNav, "onCollapse", () => {
      overlay.show();
    });

    collapseInstance.on(mobileNav, "onExpand", () => {
      overlay.hide();
    });

    // Close mobile nav when clicking overlay
    overlay.onClick(() => {
      const mobileNavToggle = document.querySelector('[data-target="#mobile-nav"]');
      if (mobileNavToggle && mobileNav.classList.contains("show")) {
        collapseInstance.toggle(mobileNav, mobileNavToggle);
      }
    });
  }
});

export default MobileNav;
